var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"slide-down"}},[(_vm.visible)?_c('div',{class:_vm.toastClasses},[(_vm.iconClass)?_c('span',{staticClass:"ui-toast-icon iconfont",class:_vm.iconClass}):_vm._e(),_c('span',{staticClass:"ui-toast-text"},[_vm._v(_vm._s(_vm.message))])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }